import SubcategoryPage from '@/components/template/SubcategoryPage';

const Backlit = () => {
  const products = [
    {
      title: "Backlit Model 1",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/backlit/model-1"
    },
    {
      title: "Backlit Model 2",
      imageSrc: "https://images.unsplash.com/photo-1586105251261-72a756497a11?auto=format&fit=crop&q=80",
      url: "/ogledala/backlit/model-2"
    },
    {
      title: "Backlit Model 3",
      imageSrc: "https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?auto=format&fit=crop&q=80",
      url: "/ogledala/backlit/model-3"
    },
    {
      title: "Backlit Model 4",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/ogledala/backlit/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Backlit"
      description="Ogledala z osvetlitvijo od zadaj, ki ustvarjajo ambientalno svetlobo in dodajajo globino vašemu prostoru. Popolna izbira za sodobne kopalnice."
      heroImage="https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Backlit;